<template>
  <div class="upload-container">
    <!-- Top Image (Centered) -->
    <div v-if="showImageTop && images.length && images[0]['url'] != null" class="image-container centered">
      <div class="preview framed">
        <img :src="imageToShow" alt="Image Preview" class="avatar" />
        <span v-if="images.length" class="remove-icon" @click="removeImage(0)">×</span>
      </div>
    </div>

    <!-- Upload Button (Centered when showImageTop, otherwise Left-Aligned) -->
    <div :class="{ 'text-center': showImageTop }">
      <b-button variant="outline-info" @click="triggerFileInput" class="upload-button">
        {{ buttonText }}
      </b-button>
    </div>

    <!-- Bottom Images in Row (Left-Aligned) -->
    <div v-if="!showImageTop && images.length" class="image-container-row">
      <div v-for="(image, index) in images" :key="index" class="preview framed">
        <img :src="image.url" alt="Image Preview" class="avatar" />
        <span class="remove-icon" @click="removeImage(index)">×</span>
      </div>
    </div>

    <!-- Hidden File Input -->
    <input type="file" ref="fileInput" @change="onFileChange" :multiple="multiple" accept="image/*"
      style="display: none;" />
  </div>
</template>

<script>
export default {
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    showImageTop: {
      type: Boolean,
      default: true, // Default to showing the image on top
    },
    buttonText: {
      type: String,
      default: 'Upload Image', // Default button text
    },
    initialImages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      images: [],
      defaultImageUrl: 'https://getbase.s3.ap-southeast-1.amazonaws.com/default_profile_image.jpg',
    };
  },
  computed: {
    imageToShow() {
      if (this.images.length) {
        return this.images[0].url;
      } else if (this.initialImages && this.initialImages.length > 0) {
        return this.initialImages[0];
      } else {
        return this.defaultImageUrl;
      }
    },
  },
  watch: {
    initialImages: {
      immediate: true,
      handler(newVal) {
        // Initialize the internal images array from initialImages only if it’s currently empty,
        // preventing overwriting any user-uploaded images while ensuring initial data is loaded.
        if (!this.images.length && newVal.length)
          this.images = newVal.map((url) => ({ url }));
      },
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      const files = event.target.files;
      if (!files.length) return;

      if (!this.multiple) {
        this.images = [];
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.onload = (e) => {
          if (this.multiple) {
            this.images.push({ file, url: e.target.result });
          } else {
            this.images = [{ file, url: e.target.result }];
          }
          this.$emit('images-changed', [...this.images]);
        };

        reader.readAsDataURL(file);
      }

      // ✅ Reset input so the same file can be uploaded again later
      this.$refs.fileInput.value = '';
    },
    removeImage(index) {
      const removed = this.images[index]; // 包含 uuid 和 url
      this.images.splice(index, 1);

      this.$emit('images-removed', removed); // ⬅ 发整个对象而不是 index
      this.$emit('images-changed', [...this.images]);
      // ✅ Reset input so user can reupload same image
      this.$refs.fileInput.value = '';
    },
    
    clear() {
      this.images = [];
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
      this.$emit('images-changed', []);
      this.$emit('images-removed', null); // optional signal
    }
  }
};
</script>

<style scoped>
/* Your existing styles */
.upload-container {
  text-align: left;
}

.image-container.centered {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.image-container-row {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.preview {
  position: relative;
  display: inline-block;
  text-align: center;
  margin-right: 10px;
}

.framed {
  padding: 20px;
  border: 2px solid #ddd;
  border-radius: 10px;
  background-color: white;
}

.preview img {
  max-width: 100px;
  max-height: 100px;
  display: block;
  border-radius: 50%;
}

.remove-icon {
  position: absolute;
  bottom: 5px;
  right: 5px;
  color: white;
  background-color: red;
  border-radius: 50%;
  cursor: pointer;
  padding: 2px 5px;
  font-size: 16px;
  line-height: 16px;
}

.upload-button {
  margin-bottom: 10px;
}
</style>
